import { Navigate, Outlet } from 'react-router-dom';
import { sdk } from '@mesa-labs/mesa-api';
import { usePermissions } from '../../../hooks/usePermissions';

type Props = { requiredPermissions: sdk.AuthPermission[] };

function PermissionGuard({ requiredPermissions }: Props) {
  const { hasPermissions } = usePermissions();

  if (!hasPermissions(requiredPermissions)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
}

export default PermissionGuard;
